import { TypingResultTutorialTypeEnum } from '../../../../api';
import { Step } from 'react-joyride';
import { SpaceTutorialSteps } from './contents/SpaceTutorialSteps';
import { UppercaseTutorialSteps } from './contents/UppercaseTutorialSteps';

export const TUTORIAL_STEPS: Record<string, Step[]> = {
  [TypingResultTutorialTypeEnum.Uppercase]: UppercaseTutorialSteps,
  [TypingResultTutorialTypeEnum.Space]: SpaceTutorialSteps,
};